import { IProviderConfig } from '../../../../common/provider-config'
import { IAd } from '../../../ad'

export abstract class AdVerifierBase {
    protected abstract URLPath: string
    protected abstract requestAds?(allAds: IAd[], adURI: string, specificAds?: IAd[]): void
    protected abstract initializeVerifier(conf: IProviderConfig): void
}
